import React from "react";
import Home_image from '../../images/Blog/home_img.png'
import Button from "../Button";

function Dream_Property() {
    return (
        <>
            {/* Dream home */}
            < div className='bg-[#363537] py-[70px] my-[80px] md:my-[120px]' >
                <div className="max-w-[1180px] mx-auto flex flex-wrap gap-y-10">
                    <div className='max-w-[420px] m-auto text-center px-6 lg:text-left lg:px-0'>
                        <h1 className='text-[35px] text-yellow font-semibold sm:text-[45px] sm:leading-[55px] '>Ready to find your Dream Home?</h1>

                        <p className='max-w-[348px] text-font-grey text-white text-[18px] leading-[25px] mt-[20px] mb-[60px]'>Lorem ipsum dolor sit amet consectetur. Vel non aenean facilisi odio tortor lacinia massa pretium porttitor.</p>

                        <Button
                            name={"Get Started Today"}
                            design={"filled"}
                            action={"external-linking"}
                            url={`#`}
                        />
                    </div>

                    <img className='mx-auto order-first lg:order-last' src={Home_image} alt='Home_bg' />
                </div>
            </div >
        </>
    )
}

export default Dream_Property;